import { TFunction } from 'react-i18next';
import { Step } from 'pages/AutomationEngine/types';
import { CardProps } from '../../types';
import DraggableStepCard from '__pages/AutomationEngine/Engine/Steps/DraggableStepCard';

import { SendTextProps } from 'pages/AutomationEngine/dialogs/ActionWizard/subsections/SendText';

const CROP_LENGTH = 47;

type GetDescription = {
  step: Step & {
    details: SendTextProps['values'];
  };
  t: TFunction;
};

export const content = ({ step }: { step: Step }) => step.description;

export const getDescription = ({ step, t }: GetDescription) => {
  if (step.details?.textObject) {
    return t(`Text ‘%{message}%%{dots}%’ to Contact.`, {
      interpolation: { prefix: '%{', suffix: '}%' },
      message: step.details.textObject?.content?.slice?.(0, CROP_LENGTH),
      dots:
        Math.max(step.details.textObject.content?.length, 0) > CROP_LENGTH
          ? '...'
          : '',
    });
  }
  // otherwise return the existing description
  return step.description;
};

export default function SendTextCard({ type, step, ...others }: CardProps) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
